export function appendEquipment(parsed, json) {
  if (!json.equipment) return;
  const equipment = json.equipment;
  if (equipment.parameters) {
    equipment.parameters = equipment.parameters.parameter;
  }
  if (equipment.normalizations) {
    json.equipment.normalizations = json.equipment.normalizations.normalization;
  }
  parsed.equipment = json.equipment;
}
